var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_455",
    "data-name": "Group 455",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 14.989,
    viewBox: "0 0 15 14.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 15,
    height: 14.989,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M0,7.174V6.91c.035-.015.028-.047.03-.075A7.047,7.047,0,0,1,.708,4.324,7.426,7.426,0,0,1,6.369.084,3.978,3.978,0,0,0,6.94,0H7.5q0,3.494,0,6.988a.268.268,0,0,0,.024.156L7.491,7.2l-.676.668c-.231.229-.4.231-.624,0q-.751-.75-1.5-1.5a.355.355,0,0,0-.58,0q-.4.377-.8.755a.346.346,0,0,0,0,.576L6.24,10.622a.351.351,0,0,0,.578,0L7.5,9.959q0,2.514,0,5.029a6.829,6.829,0,0,1-1.753-.2A7.5,7.5,0,0,1,.08,8.578a1.967,1.967,0,0,0-.08-.5V7.789a1.381,1.381,0,0,0,0-.615",
    fill: "#57af59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M191.547,7.144a.268.268,0,0,1-.024-.156q0-3.494,0-6.988h.586c.21.057.428.055.641.092a7.287,7.287,0,0,1,4.24,2.28A7.244,7.244,0,0,1,198.835,9.1a7.268,7.268,0,0,1-4.189,5.208,6.888,6.888,0,0,1-3.122.676q0-2.514,0-5.029a.07.07,0,0,0,.006-.02.264.264,0,0,0,.035-.025q2.091-2.09,4.18-4.181a.342.342,0,0,0,0-.548q-.416-.422-.838-.838a.344.344,0,0,0-.559.008c-.243.24-.483.483-.725.724l-2.073,2.066",
    transform: "translate(-184.028)",
    fill: "#2e9d49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M0,183.323a1.381,1.381,0,0,1,0,.615Z",
    transform: "translate(0 -176.149)",
    fill: "#6fb96f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M191.464,110.452l2.073-2.066c.242-.241.482-.484.725-.724a.344.344,0,0,1,.559-.008q.422.416.838.838a.342.342,0,0,1,0,.548q-2.088,2.092-4.18,4.181a.261.261,0,0,1-.035.025c0-.092-.005-.185-.005-.277q0-1.233,0-2.466l.028-.052",
    transform: "translate(-183.945 -103.308)",
    fill: "#d8e5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M85.058,159.784q0,1.233,0,2.466c0,.092,0,.185.005.277a.069.069,0,0,1-.006.02l-.677.665a.351.351,0,0,1-.578,0l-2.928-2.928a.346.346,0,0,1,0-.576q.4-.379.8-.755a.355.355,0,0,1,.58,0q.751.749,1.5,1.5c.228.228.393.226.624,0l.676-.668",
    transform: "translate(-77.567 -152.589)",
    fill: "#fdf2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIcon);
export default __webpack_public_path__ + "static/media/green_check_icon.db9c524e2f7d95e04ddfc63f78664780.svg";
export { ForwardRef as ReactComponent };